"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var PropTypes = require("prop-types");
var React = require("react");
var react_1 = require("react");
var LoaderIcon_1 = require("../Icons/LoaderIcon");
var propTypes = {
    show: PropTypes.bool,
    viewport: PropTypes.oneOf(['fixed', 'relative'])
};
/**
 * This component places a layer on top of the page in which a rotating spinner
 * is displayed in the middle.
 */
var LoadingSpinner = /** @class */ (function (_super) {
    __extends(LoadingSpinner, _super);
    function LoadingSpinner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LoadingSpinner.prototype.render = function () {
        var _a = this.props, className = _a.className, show = _a.show, viewport = _a.viewport, other = __rest(_a, ["className", "show", "viewport"]);
        var componentClassName = classNames('ee_loading-spinner', className, {
            'ee_loading-spinner--hide': !show,
            'ee_loading-spinner--relative': viewport === 'relative'
        });
        return (React.createElement("div", __assign({}, other, { className: componentClassName }),
            React.createElement(LoaderIcon_1.default, { title: "L\u00E4dt...", width: 50, height: 50, spinning: true, className: "ee_loading-spinner__icon" })));
    };
    LoadingSpinner.propTypes = propTypes;
    LoadingSpinner.defaultProps = {
        show: false,
        viewport: 'fixed'
    };
    return LoadingSpinner;
}(react_1.Component));
exports.LoadingSpinner = LoadingSpinner;
exports.default = LoadingSpinner;
//# sourceMappingURL=LoadingSpinner.js.map